import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-xhr-backend'
import Cache from 'i18next-localstorage-cache'
import sprintf from 'i18next-sprintf-postprocessor'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

const DEFAULT_LANGUAGE = 'en-US'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(Backend)
  .use(Cache)
  .use(sprintf)
  .init({
    debug: false,
    react: {
      useSuspense: false,
      wait: true,
    },
    // lng: 'pt-BR',
    fallbackLng: DEFAULT_LANGUAGE,
    whitelist: ['pt-BR', 'en-US'],
    preload: ['pt-BR', 'en-US'],
    interpolation: {
      escapeValue: false,
    },
    defaultNS: 'landing-page:index',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      allowMultiloading: true,
    },
    cache: {
      enabled: true,
      expirationTime: 24 * 60 * 60 * 1000,
    },
  })

i18n.services.pluralResolver.addRule('pt-BR', {
  name: 'pt-BR',
  numbers: [1, 2],
  plurals(n: number) {
    return Number(n !== 1)
  },
})

export function setLanguage(language: 'pt-BR' | 'en-US'): void {
  i18n.changeLanguage(language)
}

export function getCurrentLng(): 'pt-BR' | 'en-US' {
  return i18n.language || window.localStorage.i18nextLng || DEFAULT_LANGUAGE
}

export default i18n
